var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 2.73417H14.2746M3.77503 2.73417H1.5M22.5 21.4004H15.4999M5.00005 21.4004H1.5M22.4993 12.0673H20.2243M9.72512 12.0673H1.5M10.7742 2.73345C10.7742 3.7645 9.99066 4.60033 9.02414 4.60033C8.05763 4.60033 7.27412 3.7645 7.27412 2.73345C7.27412 1.70241 8.05763 0.866577 9.02414 0.866577C9.99066 0.866577 10.7742 1.70241 10.7742 2.73345ZM16.8914 12.0666C16.8914 13.0976 16.1078 13.9335 15.1413 13.9335C14.1748 13.9335 13.3913 13.0976 13.3913 12.0666C13.3913 11.0355 14.1748 10.1997 15.1413 10.1997C16.1078 10.1997 16.8914 11.0355 16.8914 12.0666ZM12.0177 21.3997C12.0177 22.4307 11.2342 23.2666 10.2676 23.2666C9.30113 23.2666 8.51762 22.4307 8.51762 21.3997C8.51762 20.3687 9.30113 19.5328 10.2676 19.5328C11.2342 19.5328 12.0177 20.3687 12.0177 21.3997Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e19cd2d3b197195c46d848f143f5849f.svg";
export { ForwardRef as ReactComponent };